import React, { useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilLockLocked } from '@coreui/icons';
import logo from '../../../assets/images/jpLogo.png';
import REACT_APP_BASE_URL from 'src/api/Api';

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {id,token} = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const passWordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

  const handleResetPassword = async (e) => {
    e.preventDefault();

    try {
      if(!passWordRegex.test(password)){
        setErrorMessage('Password must contain at least 8 characters, one uppercase, one lowercase, one number');
        return;
      }
      if (password !== confirmPassword) {
        setErrorMessage('Passwords do not match');
        return;
      }

      const response = await fetch(`${REACT_APP_BASE_URL}staff/reset-password/${id}/${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: password,
        }),
      });
      

      const data = await response.json();
      console.log("data ",data);
      if (response.ok) {
        setSuccessMessage(data.message);
        setTimeout(() => navigate('/login'), 3000);
      } else {
        setErrorMessage(data.message || 'Error resetting password. Please try again.');
      }
    } catch (error) {
      console.error('Error resetting password:', error);
      setErrorMessage('Error resetting password. Please try again.');
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center backgroundImage">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-4 form-card">
                <CCardBody>
                  <CForm
                    onSubmit={handleResetPassword}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ marginBottom: '1.2rem' }}>
                      <img src={logo} alt="logo" />
                    </div>
                    <div style={{ marginBottom: '1.2rem' }}>
                      <h2>Reset Password</h2>
                    </div>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        id='lowercase'
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Confirm Password"
                        autoComplete="current-password"
                        id='lowercase'
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </CInputGroup>
                    {errorMessage && <p className="text-danger">{errorMessage}</p>}
                    {successMessage && <p className="text-success">{successMessage}</p>}
                    <CButton color="primary" className="px-4" type="submit">
                      Reset Password
                    </CButton>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default ResetPassword;
